/**
 * Offers the referral text to the system share sheet; a browser without one gets the
 * text on the clipboard instead. Resolves 'shared', 'cancelled', 'copied' or 'failed'.
 */
export async function shareReferral(text) {
  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share({ text });
      return 'shared';
    } catch (error) {
      if (error && error.name === 'AbortError') return 'cancelled';
    }
  }
  try {
    await navigator.clipboard.writeText(text);
    return 'copied';
  } catch (_error) {
    return 'failed';
  }
}
